import React from 'react';
import img1 from '../assets/thanks/kitty1.jpg';
import img2 from '../assets/thanks/kitty2.gif';
import img3 from '../assets/thanks/kitty3.jpg';
import img4 from '../assets/thanks/kitty4.gif';
import img5 from '../assets/thanks/kitty5.gif';
import img6 from '../assets/thanks/kitty6.jpg';
import img7 from '../assets/thanks/kitty7.jpeg';
import img8 from '../assets/thanks/kitty8.jpg';
import { translate } from '../translations/translations.js';

const images = [img1, img2, img3, img4, img5, img6, img7, img8];
const randomImage = images[Math.floor(Math.random() * images.length)];

const ThanksPage = ({ name, language }) => {
  return (
    <div>
        <header className='form-header'>
          <div className='thanks-message'>
            <h2>{translate('thanks', language).replace("X", name)}:</h2>
            <img src={randomImage} className='kitty'/>
          </div>
        </header>
        <div className="form-container">
          
        </div>
    </div>
  );
};

export default ThanksPage;
